// ProfilePopup.tsx
import React from "react";
import "./styles.css";
import useAppData from "@/store/useAppData";

interface Props {
    onClose: () => void;
}

const ProfilePopup: React.FC<Props> = ({ onClose }) => {
    const user = useAppData(state => state.user);

    return (
        <div className="profile-backdrop" onClick={onClose}>
            <div className="profile-popup" onClick={e => e.stopPropagation()}>
                <h3>Profil uživatele</h3>

                <div className="profile-row">
                    <b>Uživatel:</b> {user.name}
                </div>

                <button className="profile-close" onClick={onClose}>
                    Zavřít
                </button>
            </div>
        </div>
    );
};

export default ProfilePopup;